import { render } from "./RuiNotes.vue?vue&type=template&id=43459865"
const script = {}
script.render = render

export default script